export default __webpack_public_path__ + "static/media/signature_cb.bfae5f52.png";